<template>
<div class='vx-col w-full'>
    <vs-list>
        <vs-list-item title="Institución" :subtitle="usuarioSelect.nombreInstitucion"></vs-list-item>
        <vs-list-item v-if="periodo.periodo_id > 0" title="Período" :subtitle="periodo.descripcion">
            <vs-chip v-if="periodo.estado == 1" color="success">Activo</vs-chip>
            <vs-chip v-else color="danger">Desactivado</vs-chip>
        </vs-list-item>
        <vs-list-item title="Nombre" :subtitle="usuarioSelect.nombres +' '+ usuarioSelect.apellidos"></vs-list-item>
        <vs-list-item title="Email" :subtitle="usuarioSelect.name_usuario"></vs-list-item>
        <vs-list-item title="Cédula" :subtitle="usuarioSelect.cedula"></vs-list-item>
    </vs-list>

    <vs-divider color="success">Areas seleccionadas ( {{seleccionadas.length}} ) </vs-divider>
    <vs-collapse>
        <vs-collapse-item icon-pack="feather" icon-arrow="icon-arrow-down">
            <div slot="header">
                Asignaturas ( {{seleccionadas.length}} )
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-full text-right" v-if="seleccionadas.length >1">
                    <vs-button type="border" color="danger" @click="opConfirmarQuitar=true; opConfirmarMover=false">Quitar todas <span class="feather icon icon-trash"></span></vs-button>
                    <vs-button type="filled" color="primary" @click="opConfirmarMover=true;opConfirmarQuitar=false" class="ml-2">Mover a período actual<span class="feather icon icon-refresh"></span></vs-button>
                </div>
                <transition name="fade" v-if="opConfirmarQuitar">
                    <div class="vx-col sm:w-full text-center">
                        <vs-divider />
                        <h4 class="m-3">Seguro desea QUITAR todas las asignaturas?</h4>
                        <vs-button type="filled" color="success" @click="f_quitarTodo()">Si, quitar asignaturas <span class="feather icon icon-check"></span></vs-button>
                        <vs-button type="filled" color="dark" @click="opConfirmarQuitar=false" class="ml-2">Cancelar<span class="feather icon icon-back"></span></vs-button>
                        <vs-divider />
                    </div>
                </transition>
                <transition name="fade" v-if="opConfirmarMover">
                    <div class="vx-col sm:w-full text-center">
                        <vs-divider />
                        <h4 class="m-3">Desea MOVER todas las asignaturas de {{ usuarioSelect.nombres }} {{ usuarioSelect.apellidos }} a otro periodo escolar?</h4>
                        <vs-button type="filled" color="primary" @click="moverPeriodoActual()">Si, mover a {{ periodo.descripcion }} <span class="feather icon icon-check"></span></vs-button>
                        <vs-button type="filled" color="dark" @click="opConfirmarMover=false" class="ml-2">Cancelar<span class="feather icon icon-back"></span></vs-button>
                        <vs-divider />
                    </div>
                </transition>
                <div class="vx-col sm:w-full auto-grid mt-5">
                    <div v-for="(item, index) in seleccionadas" :key="index" class="d-inline align-center m-2 p-2 border-2 asig-select text-dark width-libro-select">
                        <span class="numero-libro"> {{ index+1 }} </span>
                        <p class="btn-arriba">
                            <vs-button @click="eliminaAsignacion(item)" style="display:inline" size="small" color="danger" radius type="gradient" icon-pack="feather" icon="icon-trash"></vs-button>
                        </p>
                        <p>
                            {{item.nombreasignatura}} ( {{ item.periodoescolar }} )
                        </p>
                        <p>
                            <small> ( {{item.updated_at}} )</small>
                        </p>
                    </div>
                </div>
            </div>
        </vs-collapse-item>
    </vs-collapse>
    <div class="m-2">
        <vs-divider color=primary> Areas ( {{area.length}} ) </vs-divider>

        <div class="vx-col sm:w-full text-right">
            <vs-button type="border" color="primary" size="small" @click="reloadAreas()">Recargar areas <span class="feather icon icon-refresh-cw"></span></vs-button>
        </div>

        <vs-collapse>
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-arrow-down" v-for="(listItem, index) in area" :key="index" :title="listItem.name">
                <div slot="header">
                    {{listItem.name}}
                </div>
                <vs-button v-for="(listIAsig, indexAsig) in listItem.children" :key="indexAsig" type="border" color="primary" class="p-2 m-1" @click="agregaAsignacion(listIAsig)">
                    {{listIAsig.name}}
                </vs-button>
            </vs-collapse-item>
        </vs-collapse>
    </div>
</div>
</template>

<script>
export default {
    props: {
        usuarioSelect: {
            type: Object,
            default: () => ({})
        },
    },
    components: {},
    data() {
        return {
            seleccionadas: [],
            user_seleccionado: '',
            periodo: {},
            area: [],
            opConfirmarQuitar: false,
            opConfirmarMover: false,
            areasTemp: [],
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.user_seleccionado = me.usuarioSelect.idusuario;
        me.getPeriodo();
        me.getAreaSelect();
    },
    methods: {
        getPeriodo() {
            let me = this
            me.$vs.loading();
            this.$http.get(this.$server_url + "institucionTraerPeriodo?institucion_id=" + me.usuarioSelect.institucion_idInstitucion)
                .then(function (res) {
                    if (res.data.length == 0) {
                        me.periodo.periodo_id = 0
                        me.periodo.estado = 0
                        me.periodo.descripcion = ""
                    }
                    let datos = res.data[0]
                    me.periodo.periodo_id = datos.periodo
                    me.periodo.estado = datos.estado
                    me.periodo.descripcion = datos.descripcion
                    me.getSeleccionadas();
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    me.$vs.loading.close();
                });
        },
        getAreaSelect() {
            let me = this;
            me.areasTemp = JSON.parse(localStorage.getItem('areasAsignaciones'))
            if (me.areasTemp != null) { //si existe las areas previamente guardadas, ya no se consulta a la base.
                me.area = me.areasTemp;
                return;
            }
            me.$vs.loading();
            this.$http.get(this.$server_url + "areaSelect")
                .then(function (response) {
                    me.area = response.data.items;
                    localStorage.setItem("areasAsignaciones", (JSON.stringify(me.area)));
                    // console.log(me.area);
                    me.$vs.loading.close();
                })
                .finally(() => {
                    me.$vs.loading.close();
                });
        },
        getSeleccionadas() {
            let me = this;
            let data = new FormData();
            me.$vs.loading();
            data.append('idusuario', me.user_seleccionado)
            this.$http.post(this.$server_url + "asignaturasDocent", data)
                .then(res => {
                    // console.log('areas', res.data);
                    me.seleccionadas = res.data;
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    me.f_notificaciones('No se obtuvieron datos del usuario seleccionado', 'danger', 'alert-triangle')
                })
                .finally(() => {
                    me.$vs.loading.close();
                });
        },
        f_quitarTodo() {
            let me = this;
            let idSelects = [];
            for (let index = 0; index < me.seleccionadas.length; index++) {
                idSelects.push(me.seleccionadas[index].idasignado)
            }
            me.$vs.loading();
            let data = new FormData();
            data.append('idasiguser', idSelects)
            this.$http.post(this.$server_url + "quitaTodasAsignaturas", data)
                .then(function (res) {
                    // console.log(res.data);
                    me.opConfirmarQuitar = false;
                    me.f_notificaciones('Asignaturas quitadas correctamente.')
                    me.getSeleccionadas();
                    me.$vs.loading.close();
                })
                .finally(() => {
                    me.$vs.loading.close();
                });
        },
        moverPeriodoActual() {
            let me = this
            this.$http.get(this.$server_url + 'moverAsignaturasPeriodo/' + me.user_seleccionado + '/' + me.periodo.periodo_id)
                .then(function (res) {
                    me.f_notificaciones('ASignaturas movidas correctamente.')
                    me.opConfirmarMover = false;
                    me.getSeleccionadas();
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
                .finally(() => {
                    me.$vs.loading.close();
                });
        },
        agregaAsignacion(item) {
            let me = this;
            let data = new FormData();
            if (me.periodo.periodo_id == 0) {
                me.f_notificaciones('La institución no tiene período', 'danger', 'icon-alert-triangle')
                return
            }
            if (me.periodo.estado == 0) {
                me.f_notificaciones('La institución tiene período inactivo', 'danger', 'icon-alert-triangle')
                return
            }
            data.append('usuario_idusuario', me.user_seleccionado)
            data.append('asignatura_idasignatura', item.id)
            me.$vs.loading();
            this.$http.post(this.$server_url + "asignar_asignatura_docentes", data)
                .then(function (res) {
                    // console.log(res.data);
                    if (res.data > 0) {
                        me.f_notificaciones('Esta asignatura ya se encuentra asignada al docente', 'danger', 'icon-alert-triangle')
                    } else {
                        me.f_notificaciones('Asignatura agregada')
                        me.getSeleccionadas();
                    }
                    me.$vs.loading.close();
                })
                .finally(() => {
                    me.$vs.loading.close();
                });
        },
        eliminaAsignacion(item) {
            let me = this;
            // console.log(item)
            me.$vs.loading();
            this.$http.get(this.$server_url + "eliminaAsignacion/" + item.idasignado)
                .then(function (res) {
                    // console.log(res.data);
                    me.f_notificaciones(item.nombreasignatura + ' eliminada')
                    me.getSeleccionadas();
                    me.$vs.loading.close();
                })
                .finally(() => {
                    me.$vs.loading.close();
                });
        },
        reloadAreas() {
            let me = this;
            localStorage.removeItem('areasAsignaciones');
            me.getAreaSelect();
        },
        f_notificaciones(msj = "Sin mensaje", color = "success", icono = "icon-check", time = 4000) {
            let me = this;
            me.$vs.notify({
                text: msj,
                color: color,
                iconPack: 'feather',
                icon: icono
            })
            return;
        }
    }
};
</script>

<style scoped>
.width-libro-select {
    display: flex;
    flex-flow: column nowrap;
    padding: 1rem;
    background-image: linear-gradient(to top, rgba(236, 239, 245, 0.5), rgba(223, 228, 236, 0.7));
    border: 1px solid #999;
    border-radius: 5px;
}

.auto-grid {
    display: -ms-grid;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
    grid-gap: 1rem;
    /* background-image: linear-gradient(135deg, #D4FFCC 25%, #F2F2F2 25%, #F2F2F2 50%, #D4FFCC 50%, #D4FFCC 75%, #F2F2F2 75%, #F2F2F2 100%); */
    background-size: 50px 50px;
}

.numero-libro {
    background: rgb(236, 239, 245);
    color: rgb(29, 29, 29);
    border: 1px solid #999;
    font-size: 1.2rem;
    margin-top: -20px;
    padding-left: 7px;
    border-radius: 50%;
    width: 32px;
}

.btn-arriba {
    margin: -15px 50% 15px 50%;
}
</style>
